import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { BODY_PREVIEW } from 'customer-data-objects/task/TaskPropertyNames';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TaskNotesCell({
  original: cdtTask
}) {
  const notes = getProperty(cdtTask, BODY_PREVIEW);
  if (!notes) {
    return '--';
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: notes
  });
}